import React from 'react'
import MainLandingPage from './Pages/MainLandingPage'
import {Routes,Route} from 'react-router-dom'
import Error from './Component/Error/Error'
import Privacy from './Component/Privacy'
import Refund from './Component/Refund'
import Terms from './Component/Terms'

function Navigation() {
  return (
    <div>
        <Routes>
            <Route path='/' element={<MainLandingPage/>}/>
            <Route path='/error' element={<Error/>}/>
            <Route path="/privacy" element={<Privacy/>}/>
            <Route path="/refund" element={<Refund/>}/>
            <Route path="/terms" element={<Terms/>}/>
        </Routes>
        
    </div>
  )
}

export default Navigation